import ArrowLeft from "@/assets/icons/ArrowLeft";
import FlexPass from "@/assets/icons/FlexPass";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import Screen from "@/components/layout/Screen";
import AppButton from "@/components/shared/AppButton";
import PassDetailCard from "@/components/shared/InfoCard/PassDetailCard";
import PageTitle from "@/components/shared/PageTitle/PageTitle";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { useCustomTheme } from "@/hooks/useCustomTheme";
import { prettyPassID } from "@/utils/etc";
import { T, useT } from "@transifex/react";
import { useLocalSearchParams, useRouter } from "expo-router";
import type { Pass } from "ipctg-inflow-types/InFlowDB";
import QRCode from "react-native-qrcode-svg";

const PassDetail = () => {
  const router = useRouter();
  const param = useLocalSearchParams<{ pass: string }>();
  const t = useT();
  const { skin } = useCustomTheme();

  let pass: Pass | null = null;
  try {
    if (!param) {
      throw new Error();
    }
    pass = JSON.parse(param.pass) as Pass;
  } catch {
    throw new Error("Pass object is undefined");
  }

  return (
    <ProtectedRoute>
      <Screen>
        <>
          <PageTitle title={pass?.passName ?? ""}>
            <HStack className="items-center justify-center gap-[8px]">
              <FlexPass />
              <Text className="font-[700] text-[12px] text-typography-900 tracking-[0.13em]">
                <T _str="FLEX PARK" />
              </Text>
            </HStack>
          </PageTitle>
          {pass && <PassDetailCard pass={pass} />}
        </>
        <AppButton icon={ArrowLeft} onPress={() => (router.canGoBack() ? router.back() : router.replace("/my-passes"))} title={t("Back to passes")} />
        <VStack className="items-center justify-center gap-1">
          <Text className="font-[700] text-[12px] text-typography-900 mb-1">For customer service</Text>
          <QRCode value={prettyPassID(pass.passID)} color={skin.theme.light.typography[900]} size={80} />
          <Text className="font-[400] text-[12px] text-typography-900 mt-1">{prettyPassID(pass.passID)}</Text>
        </VStack>
      </Screen>
    </ProtectedRoute>
  );
};

export default PassDetail;
